import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'capacity.ui.feedback-button.title',
		defaultMessage: 'Give feedback',
		description: 'Tooltip and title for capacity feedback button',
	},
});
